import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  buttonsWrapper: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
}));
